<template>
  <div class="codelogin">
    <div>
      <div class="title">
        密码观看
      </div>
      <div class="input_view">
        <div class="phone_view">
          密码
          <input class="input_phone" placeholder="请输入密码" v-model="pwd"/>
        </div>
        <div style="font-size: 12px;padding-left: 120px;padding-top: 24px;">
          <span style="color: #4256FB;">忘记密码？</span><span>请联系直播管理员获取</span>
        </div>
      </div>
      <el-button class="sumbit" @click="gosumbit" :loading="show_pswloading">
        进入
      </el-button>
    </div>
  </div>
</template>
<script>

export default {
    name: "pwdlogin",
    props: {},
    data() {
        return {
            pwd: "",
            show_pswloading: false
        };
    },
    mounted() {
    },
    methods: {
        gosumbit() {
            this.show_pswloading = true;
            this.$liveapi.roomwatchytypeencryption(this.pwd).then(res => {
                console.log(res.data);
                if (res.data.code === 200) {
                    this.show_pswloading = false;
                    this.$message({
                        message: "验证成功",
                        type: "success"
                    });
                    setTimeout(() => {
                        location.reload();
                    }, 1000);
                }
                else {
                    this.show_pswloading = false;
                }
            }).catch(err => {
                this.show_pswloading = false;
            });
        },
    },
}
</script>
<style scoped>
.codelogin{
    width: 392px;
    height: 500px;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1500);
    z-index: 2;
    background-color: #fff;
    border-radius: 5px;
}
.title{
  padding-top: 52px;
  font-size: 20px;
  font-weight: 550;
  text-align: left;
  text-indent: 2em;
  /* margin-top: 20px; */
}
.code_view{
  width: 220px;
  height: 220px;
  background: url(../../assets/login/subtract.png);
  background-size: 100%;
  margin: 80px auto;
}
.code_view>img{
  width: 180px;
  height: 180px;
  margin: 20px;
}
.input_view{
  width: 306px;
  margin: 45px auto;
}
.phone_view{
  padding-left: 16px;
  width: 300px;
  height: 46px;
  background: #EFF6FF;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 46px;
  border-radius: 5px;
}
.input_phone{
  width:200px;
  margin-left: 8px;
  font-size: 14px;
  padding-left: 16px;
  background-color: transparent;
  border: 0;
  outline: transparent;
  border-left: 1px solid #CEE2FF;
}
.code_phone{
  float: left;
  width:214px;
  height: 56px;
  font-size: 18px;
  padding-left: 16px;
  background: #EFF6FF;
  border: 0;
  outline: transparent;
  border-radius: 5px;
}

.sumbit{
  width: 306px;
  height: 46px;
  background: linear-gradient(171deg, #3EA2FF 0%, #4558FC 100%);
  border-radius: 30px;
  color: #fff;
  font-size: 16px;
  margin: 130px auto;
}
.slide_verify{
  position: absolute;
  bottom: 160px;
  z-index: 10;
}
</style>
